define('app/views/confirm_view',['app/setup'], function (takhfifan) {
  takhfifan.confirmView = takhfifan.MessageView.extend({

    events: {
      'click .tkh-confirm__apply': 'close'
    },

    initialize: function () {
      takhfifan.eventHub.on('confirm:showMessage', function (options) {
        this.showConfirm(options);
      }, this);
      /*takhfifan.eventHub.on('confirm:showConthis.showConfirm(options);
      //TODO #NEXT Add ok cancel confirm dialog
      }, this);*/
    },
    close: function () {
      this.$el.fadeOut(300);
      takhfifan.eventHub.trigger('modal:closeModalWithContent');
    },

    removeOldContent: function () {
      this.$el.find('#tkh-confirm-content').remove();
    },

    getIconClass: function (type, defaultIcon) {
      var iconClasses = 'icon-error';
      switch (type) {
        case "error":
          iconClasses = 'icon-error red';
          break;
        case "notice":
          iconClasses = 'icon-info blue';
          break;
        case "success":
          iconClasses = 'icon-check green';
          break;
        case "warning":
          iconClasses = 'icon-warning orange';
          break;
        default:
          iconClasses = defaultIcon;
      }
      return iconClasses;
    },

    showConfirm: function (options) {
      var template = _.template(this.$el.find('#confirm-one-button-template').html());
      this.removeOldContent();
      this.$el.append(template(
        {
          msg: options.msg ? options.msg : '',
          iconClasses: this.getIconClass(options.type, 'none'),
          okText: options.btnTxt ? options.btnTxt : 'تایید'
        }));

      takhfifan.eventHub.trigger(
        'modal:showModalWithContent', {
          elementToOperate: this.$el,
          fadeTimeIn: options.fadeTimeIn ? options.fadeTimeIn : 400
        });
    }
  });
});

